import { useEffect, useState } from "react"
import type { SyncStatus } from "../../../lib/offline/types"
import { useAISync } from "../providers/AISyncProvider"

export interface AISyncStatusInfo {
  status: SyncStatus
  pendingCount: number
}

const POLL_INTERVAL_MS = 1_000

export function useAISyncStatus(): AISyncStatusInfo {
  const { engine, changeQueue } = useAISync()
  const [status, setStatus] = useState<SyncStatus>(engine.status)
  const [pendingCount, setPendingCount] = useState(0)

  useEffect(() => {
    let mounted = true
    let timer: ReturnType<typeof setTimeout>

    async function poll() {
      if (!mounted) return
      setStatus(engine.status)
      const pending = await changeQueue.getPending()
      if (mounted) {
        setPendingCount(pending.length)
        timer = setTimeout(poll, POLL_INTERVAL_MS)
      }
    }

    void poll()
    return () => {
      mounted = false
      clearTimeout(timer)
    }
  }, [engine, changeQueue])

  return { status, pendingCount }
}
